/**
 * 该部分实现 规格字段 对应的表格单元格
 */
import Sku from './sku.vue';
export default Sku;
